import { CopyText } from 'modules/common/components/CopyText/CopyText'
import { useCountryExternalLinks } from 'modules/common/hooks/useCountryExternalLinks'
import { useTranslation } from 'modules/common/hooks/useTranslation'
import { trackEvent } from 'modules/common/lib/amplitude/trackEvent'
import { EnumSettingsTrackingEvent } from 'modules/settings/lib/tracking/events'

interface Props {
  voucherCode: string
  refereeReward: number
}

export const SponsorshipVoucherCode = ({
  voucherCode,
  refereeReward,
}: Props) => {
  const { t } = useTranslation('settings-components')
  const { sponsorshipInvitationLink } = useCountryExternalLinks()

  return (
    <div className="mb-8 w-full rounded-xl bg-white p-6 shadow-md">
      <h3>{t('sponsorshipOfferContainer.voucherCode.title')}</h3>
      <p className="pb-4">
        {t('sponsorshipOfferContainer.voucherCode.description')}
      </p>
      <div className="flex rounded-lg border border-dashed border-info-300">
        <span className="grow px-4 py-3 text-left text-2xl font-bold">
          {voucherCode}
        </span>
        <CopyText
          textToCopy={t('sponsorshipOfferContainer.voucherCode.textToCopy', {
            sponsorshipInvitationLink,
            voucherCode,
            refereeReward,
          })}
          variant="primary"
          className="-m-px min-w-[120px]"
          onCopy={() => {
            trackEvent({
              eventType:
                EnumSettingsTrackingEvent.SPONSORSHIP_COPY_VOUCHER_CODE,
            })
          }}
        />
      </div>
    </div>
  )
}
